<template>
  <tr>
    <td
      class="align-content-start border-end text-end pe-1"
      :rowspan="showDetail? 2: 1"
    >
      {{ index + 1 }}
    </td>
    <td
      class="align-content-start"
    >
      <span class="fw-medium">{{ $ln(variant) }}</span>
    </td>
    <td
      class="align-content-start"
    >
      <div class="input-group-sm ">
        <input
          type="number"
          inputmode="decimal"
          v-model.number="v$.variant.price.$model"
          class=" form-control shadow-none text-end"
          :placeholder="$t('Enter price') + '...'"
        >
        <div v-for="error of v$.variant.price.$errors"
          class="d-block invalid-feedback"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
    </td>
    <td
      class="align-content-start"
    >
      <div class="input-group-sm ">
        <input
          type="number"
          inputmode="decimal"
          v-model.number="v$.variant.compare_at_price.$model"
          class=" form-control shadow-none text-end"
          :placeholder="$t('Compare at price') + '...'"
        >
        <div v-for="error of v$.variant.compare_at_price.$errors"
          class="d-block invalid-feedback"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
    </td>
    <td
      class="align-content-start"
    >
      <div class="input-group-sm">
        <input
          type="number"
          inputmode="decimal"
          v-model.number="v$.variant.cost_manual.$model"
          class=" form-control shadow-none text-end"
          :placeholder="variant.cost_estimate || ($t('Enter cost') + '...')"
        >
        <div v-for="error of v$.variant.cost_manual.$errors"
          class="d-block invalid-feedback"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
    </td>
    <td
      class="align-content-start"
    >
      <div class="input-group-sm ">
        <input
          type="text"
          v-model.trim="v$.variant.code.$model"
          class=" form-control shadow-none"
          :placeholder="$t('Enter SKU') + '...'"
        >
        <div v-for="error of v$.variant.code.$errors"
          class="d-block invalid-feedback"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
    </td>
    <td
      class="align-content-start"
    >
      <div class="form-check form-switch">
        <input
          class="form-check-input shadow-none"
          type="checkbox"
          v-model.trim="v$.variant.is_active.$model"
        >
      </div>
    </td>
    <td
      class="align-content-start"
    >
      <button
        type="button"
        class="btn btn-sm btn-icon"
        :class="showDetail? 'btn-theme': 'btn-outline-secondary'"
        style="
          width: 26px;
          height: 26px;
          padding: 0;
        "
        @click="() => {
          showDetail = !showDetail
        }"
      >
        <i :class="['fa-solid', showDetail? 'fa-angle-up': 'fa-angle-down']"/>
      </button>
    </td>
  </tr>
  <tr
    v-if="showDetail"
  >
    <td
      colspan="8"
    >
      <div
        class="row g-3 py-2"
        style="width: 99% !important;"
      >
        <div class="col-md-6">
          <label
            for="name"
            class="form-label"
          >
            {{ $t('Name (TH)') }}
            <span class="text-danger">*</span>
          </label>
          <div class="input-group-sm">
            <input
              id="name"
              type="text"
              v-model.trim="v$.variant.name.$model"
              class="form-control shadow-none"
              :placeholder="$t('Enter product name') + '...'"
            >
            <div v-for="error of v$.variant.name.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label
            for="name_en"
            class="form-label"
          >
            {{ $t('Name (EN)') }}
          </label>
          <div class="input-group-sm">
            <input
              id="name_en"
              type="text"
              v-model.trim="v$.variant.name_en.$model"
              class="form-control shadow-none"
              :placeholder="$t('Enter product name in English') + '...'"
            >
            <div class="form-text text-muted">{{ $t('Leave blank to show the Thai name.') }}</div>
            <div v-for="error of v$.variant.name_en.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label
            for="barcode"
            class="form-label"
          >
            {{ $t('Barcode') }}
            <span class="text-danger">*</span>
          </label>
          <div class="input-group input-group-sm">
            <input
              id="barcode"
              type="text"
              v-model.trim="v$.variant.barcode.$model"
              class="form-control shadow-none"
              :placeholder="$t('Enter product barcode') + '...'"
            >
            <button
              class="input-group-text"
              @click="generateBarcode()"
            >
              <i
                class="fa-solid fa-rotate"
              />
            </button>
            <div v-for="error of v$.variant.barcode.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
        </div>
        <div class="col md-6">
          <label for="images" class="form-label">{{ $t('Media') }}</label>
          <VueUploadMultipleImage
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"
            @edit-image="editImage"
            @limit-exceeded="limitExceeded"
            :id-upload="'variant-upload-' + index"
            :edit-upload="'variant-edit-' + index"
            :multiple="false"
            :data-images="images"
            :max-image="image.maxImage"
            :show-primary="image.showPrimary"
            :show-edit="image.showEdit"
            id-upload="myIdUpload"
            edit-upload="myIdEdit"
            :drag-text="$t('Drage Image')"
            :browse-text="$t('Browse Image')"
            primary-text="Base image"
            mark-is-primary-text="Set base image"
            popup-text="default base image"
            :drop-text="$t('Drag and drop')"
          />
          <span class="form-text text-muted">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
              <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
            </svg>
            {{ this.maxUploadImg }}
          </span>
        </div>
        <div class="col-md-6">
          <label for="description" class="form-label">{{ $t('Description (TH)') }}</label>
          <vue-editor
            v-model="v$.variant.description.$model"
            :editor-toolbar="editor.toolbar"
            :placeholder="$t('Enter description') + '...'"
            :class="v$.variant.description.$error? 'is-invalid': ''"
          />
          <div v-for="error of v$.variant.description.$errors"
            class="invalid-feedback"
            :key="error.$uid"
          >
            {{ error.$message }}
          </div>
        </div>
        <div class="col-md-6">
          <label for="description_en" class="form-label">{{ $t('Description (EN)') }}</label>
          <vue-editor
            v-model="v$.variant.description_en.$model"
            :editor-toolbar="editor.toolbar"
            :placeholder="$t('Enter description in English') + '...'"
            :class="v$.variant.description_en.$error? 'is-invalid': ''"
          />
          <div class="form-text text-muted">{{ $t('Leave blank to show the Thai description.') }}</div>
          <div v-for="error of v$.variant.description_en.$errors"
            class="invalid-feedback"
            :key="error.$uid"
          >
            {{ error.$message }}
          </div>
        </div>
        <div class="col-md-12">
          <label class="form-label d-block">
            🍽️ {{ $t('Dine-in only') }}
          </label>
          <div class="form-check form-switch">
            <input
              class="form-check-input shadow-none"
              type="checkbox"
              v-model="v$.variant.dine_in_only.$model"
              :id="'dineInOnly'+index"
            >
            <label
              class="form-check-label small text-secondary"
              :for="'dineInOnly'+index"
            >
              {{ $t('Cannot be ordered for takeaway or delivery.') }}
            </label>
          </div>
        </div>
      </div>
      <div class="border-bottom mb-3 px-3 py-2">
        <b>
          {{ $t('Portions') }}
        </b>
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-md-3">
            <label
              :for="'servingSize'+index"
              class="form-label"
            >
              {{ $t('Serving Size') }}
            </label>
            <div class="input-group input-group-sm">
              <input
                :id="'servingSize'+index"
                type="number"
                inputmode="numeric"
                v-model.number="v$.variant.serving_size_value.$model"
                class="form-control shadow-none w-25"
                :placeholder="$t('Enter serving size') + '...'"
              >
              <select
                class="form-select shadow-none"
                v-model.trim="v$.variant.serving_size_unit_id.$model"
                style="text-transform: capitalize"
                :placeholder="$t('Select serving size') + '...'"
              >
                <option
                  v-for="unit in $parent.selectOptionServingSizeUnits"
                  :value="unit.id"
                  style="text-transform: capitalize"
                >
                  {{ unit.text }}
                </option>
              </select>
              <div v-for="error of v$.variant.serving_size_value.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <div v-for="error of v$.variant.serving_size_unit_id.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="Tax" class="form-label">
              {{ $t('Main Unit') }}
            </label>
            <select2
              v-model.trim="v$.variant.unit_id.$model"
              :options="$parent.select2FormUnit.options"
              :settings="$parent.select2FormUnit.setting"
            />
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-variant";
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';
import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue';
import { VueEditor } from "vue3-editor";
import { randomString } from '@/utils/helpers';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.variant)
  },
  props: {
    variant: {
      type: Object,
      default: []
    },
    index: {
      type: Number,
      required: true
    },
    units: {
      type: Array,
      default: []
    }
  },
  data() {
    let vm = this;
    return {
      showDetail: false,
      image: {
        maxImage: 1,
        maxSize: 5,
        showPrimary: false,
        showEdit: false
      },
      images: [],
      // ชุดปุ่มเดียวกับฟอร์มสินค้าแม่ — คำบรรยายไปโผล่บนเมนูเป็นข้อความล้วน
      // จึงเหลือไว้แค่เน้นคำกับลิสต์ (ดู products/OffcanvasForm.vue)
      editor: {
        toolbar: [
          ["bold", "italic", "underline"],
          ["clean"],
        ],
      },
    }
  },
  components: {
    Select2,
    VueUploadMultipleImage,
    VueEditor,
  },
  methods: {
    generateBarcode(type = 'barcode') {
      type === 'sku'?  this.variant.code = this.variant.barcode = randomString(10): this.variant.barcode = randomString(10);
    },
    uploadImageSuccess(formData, index, fileList, fileSize) {
      let imgSize = fileSize / 1000000;
      let imgList = fileList;
      if (index >= this.image.maxImage || imgSize > this.image.maxSize) {
        imgList.splice(index, 1);
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
        return;
      }
      this.images = imgList;
      this.variant.image = imgList[0].path;
    },
    beforeRemove(index, done, fileList, mediaId) {
      if (mediaId) this.variant.remove_image = mediaId;
      done();
      this.images = fileList;
      this.variant.image = '';
    },
    editImage(formData, index, fileList) {
      // "แก้รูป" = ทับรูปเดิม → ต้องส่ง remove_image ของเก่าไปด้วย (ดู products/OffcanvasForm.vue)
      const current = fileList[index];
      if (current?.id) this.variant.remove_image = current.id;
      this.images = fileList;
      this.variant.image = current.path;
    },
    limitExceeded(limit) {
      this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
  },
  async mounted() {
    if (this.variant.images) {
      this.images = this.variant.images.map((v, k) => {
        return {
          id: v.id,
          default: 1,
          highlight: k == 0? 1: 0,
          name: v.file_name,
          path: v.image_url,
          type: 'old'
        }
      });
    }
  },
  computed: {
    maxUploadImg: function() {
      return this.$t('You can choose to upload a maximum of') + ' ' + this.image.maxImage + ' ' + this.$t('imaes. The size is not over') + ' ' + this.image.maxSize + ' ' + this.$t('MB.');
    },
    servingSizeUnit: function() {
      return this.units.filter(v => v.id == this.$parent.form.serving_size_unit_id).text;
    }
  },
  watch: {
  }
}
</script>
